export default defineNuxtPlugin({
	name: 'sentry',
	async setup() {
		const {
			sentry: { dsn, projectName, release, isDebugModeEnabled },
			ORIGIN
		} = useRuntimeConfig().public;

		const environmentMap = {
			production: 'https://pilarhomes.com.br',
			staging: 'https://staging.pilarhomes.com.br'
		};

		const currentOrigin = window?.location.origin ?? ORIGIN;

		const environment =
			Object.entries(environmentMap).find(([, url]) =>
				currentOrigin.includes(url)
			)?.[0] || 'development';

		import('@sentry/nuxt').then(Sentry => {
			Sentry.init({
				dsn,
				release: `${projectName}@${release}`,
				environment,
				integrations: [
					Sentry.replayIntegration({
						networkDetailAllowUrls: [window?.location.origin, ORIGIN],
						maskAllInputs: false,
						maskAllText: false,
						blockAllMedia: false,
						mutationBreadcrumbLimit: 500
					}),
					Sentry.replayCanvasIntegration(),
					Sentry.browserProfilingIntegration()
				],
				debug: isDebugModeEnabled,
				tracesSampleRate: 1.0,
				tracePropagationTargets: [
					'localhost',
					'https://pilarhomes.com.br',
					'https://pilarhomes.com.br/api/',
					'https://staging.pilarhomes.com.br',
					'https://staging.pilarhomes.com.br/api/'
				],
				trackComponents: true,
				replaysSessionSampleRate: 0.1,
				replaysOnErrorSampleRate: 1.0
			});
		});
	}
});
